import React, { useState, useEffect, useContext, useMemo } from "react";

import ActionContext from "context/ActionContext";
import _ from "lodash";
import styled from "styled-components";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  const [totalRows, setTotalRows] = useState(0);

  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);
 
  useEffect(() => {
    setStructureData(action.parameters?.impact?.targetedenergy || []);
  }, [JSON.stringify(action.parameters?.impact?.targetedenergy)]);

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        <TableName>Simulation</TableName>
      </>
    );
  }, []);

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
    },
  };
}
